import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Spin, message } from 'antd';
import {
  EnvironmentOutlined,
  TeamOutlined,
  TrophyOutlined,
  ArrowRightOutlined,
  GiftOutlined,
  QrcodeOutlined,
  CopyOutlined,
  NotificationOutlined,
} from '@ant-design/icons';
import PortalLayout from '../../components/portal';
import SingleCompetition from '../../components/single_competition';
import { get } from '../../commons/http';
import styles from './style.less';
import qqGroupQr from '../../assets/logos/qq-group-qr.png';

// ===== 官方通知群配置 =====
const QQ_GROUP = {
  name: '超图杯河南工业大学校赛官方通知群',
  number: '947787373',
  desc: '赛事通知、答疑交流、赛程提醒，第一时间同步',
  qrImg: qqGroupQr,
};

// 奖项配置：名额按参赛队伍总数 M 的比例计算（向下取整），不写死数量
// prizeImg 留空即显示占位符，确定奖品后填入图片路径即可
// 奖品图放入 src/assets/awards/ 目录后 import 使用，例如：
// import prizeFirst from '../../assets/awards/first.png';
const AWARDS = [
  {
    level: '一等奖',
    medal: '🥇',
    ratio: 0.05,
    countDesc: 'M × 5%（向下取整）',
    extra: '获奖证书 + 奖品',
    cls: 'gold',
    prizeImg: null, // 预留：填入奖品图片
  },
  {
    level: '二等奖',
    medal: '🥈',
    ratio: 0.1,
    countDesc: 'M × 10%（向下取整）',
    extra: '获奖证书 + 奖品',
    cls: 'silver',
    prizeImg: null, // 预留：填入奖品图片
  },
  {
    level: '三等奖',
    medal: '🥉',
    ratio: 0.25,
    countDesc: 'M × 25%（向下取整）',
    extra: '获奖证书 + 奖品',
    cls: 'bronze',
    prizeImg: null, // 预留：填入奖品图片
  },
  {
    level: '优胜奖',
    medal: '🏅',
    ratio: null,
    countDesc: '若干',
    extra: '比赛纪念品 + 获奖证书',
    cls: 'finalist',
    prizeImg: null, // 预留：填入奖品图片
  },
];

export default class Landing extends Component {
  state = {
    competitions: [],
    loading: true,
  };

  componentDidMount() {
    this.fetchCompetitions();
  }

  fetchCompetitions = async () => {
    try {
      const response = await get('/competition/all');
      if (response.code === 0) {
        this.setState({
          competitions: response.data.competitions || [],
          loading: false,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  copyQQ = (num) => {
    const done = () => message.success('群号已复制', 1.5);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(num).then(done).catch(() => message.info('群号：' + num, 3));
    } else {
      message.info('群号：' + num, 3);
    }
  };

  render() {
    const { competitions, loading } = this.state;
    // 官网首页最多展示 3 个进行中/未开始的赛事
    const featured = competitions
      .filter((c) => c.status === 0 || c.status === 1)
      .slice(0, 3);
    const showList = featured.length > 0 ? featured : competitions.slice(0, 3);

    return (
      <PortalLayout>
        {/* Hero 区 */}
        <section className={styles.hero}>
          <div className={styles['hero-inner']}>
            <div className={styles['hero-badge']}>
              <EnvironmentOutlined /> GIS 学科竞赛 · 校赛选拔
            </div>
            <h1 className={styles['hero-title']}>
              超图杯 · 河南工业大学
              <br />
              校赛报名系统
            </h1>
            <p className={styles['hero-desc']}>
              以地理信息之力，绘智慧城市蓝图。组队报名、作品提交、评审公示，一站式完成。
            </p>
            <div className={styles['hero-actions']}>
              <Link to="/portal/competition">
                <Button
                  type="primary"
                  size="large"
                  className={styles['cta-primary']}
                >
                  浏览赛事 <ArrowRightOutlined />
                </Button>
              </Link>
              <Link to="/register">
                <Button size="large" className={styles['cta-ghost']}>
                  立即注册报名
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* 特性区 */}
        <section className={styles.features}>
          <div className={styles['features-inner']}>
            <div className={styles.feature}>
              <EnvironmentOutlined className={styles['feature-icon']} />
              <h3>GIS 专业赛事</h3>
              <p>聚焦地理信息系统应用开发，贴近真实行业场景命题。</p>
            </div>
            <div className={styles.feature}>
              <TeamOutlined className={styles['feature-icon']} />
              <h3>组队参赛</h3>
              <p>
                创建队伍生成专属邀请码，队友凭码一键加入。
                <Link to="/portal/team-board">前往组队求助 →</Link>
              </p>
            </div>
            <div className={styles.feature}>
              <TrophyOutlined className={styles['feature-icon']} />
              <h3>在线评审</h3>
              <p>作品在线提交、评委在线评分，结果实时可查。</p>
            </div>
          </div>
        </section>

        {/* 奖项与奖品 */}
        <section className={styles.awards}>
          <div className={styles['awards-inner']}>
            <h2 className={styles['section-title']}>奖项设置</h2>
            <p className={styles['section-sub']}>
              M 为参赛队伍总数，各奖项名额按比例向下取整
            </p>
            <div className={styles['awards-grid']}>
              {AWARDS.map((a) => (
                <div
                  key={a.level}
                  className={`${styles['award-card']} ${styles[a.cls]}`}
                >
                  <div className={styles['award-medal']}>{a.medal}</div>
                  <h3 className={styles['award-level']}>{a.level}</h3>
                  <p className={styles['award-count']}>{a.countDesc}</p>
                  {/* 奖品位：预留，奖品确定后放入图片即可展示 */}
                  <div className={styles['award-prize']}>
                    {a.prizeImg ? (
                      <img src={a.prizeImg} alt={`${a.level}奖品`} />
                    ) : (
                      <div className={styles['prize-placeholder']}>
                        <GiftOutlined />
                        <span>奖品揭晓在即</span>
                      </div>
                    )}
                  </div>
                  <p className={styles['award-extra']}>{a.extra}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 官方通知群 */}
        <section className={styles.contact}>
          <div className={styles['contact-inner']}>
            <div className={styles['contact-card']}>
              <div className={styles['contact-left']}>
                <div className={styles['contact-badge']}>
                  <NotificationOutlined /> 官方通知
                </div>
                <h2 className={styles['contact-title']}>{QQ_GROUP.name}</h2>
                <p className={styles['contact-desc']}>{QQ_GROUP.desc}</p>
                <div className={styles['contact-number']}>
                  <span className={styles['contact-num-label']}>QQ 群号</span>
                  <span className={styles['contact-num']}>{QQ_GROUP.number}</span>
                  <Button
                    size="small"
                    icon={<CopyOutlined />}
                    className={styles['copy-btn']}
                    onClick={() => this.copyQQ(QQ_GROUP.number)}
                  >
                    复制
                  </Button>
                </div>
              </div>
              <div className={styles['contact-qr']}>
                {QQ_GROUP.qrImg ? (
                  <img src={QQ_GROUP.qrImg} alt="QQ群二维码" />
                ) : (
                  <div className={styles['qr-placeholder']}>
                    <QrcodeOutlined />
                    <span>扫码入群</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* SuperMap 资源 */}
        <section className={styles.resources}>
          <div className={styles['resources-inner']}>
            <h2 className={styles['section-title']}>参赛资源</h2>
            <p className={styles['section-sub']}>
              软件下载与许可申请，一站式备齐参赛工具
            </p>
            <div className={styles['resources-grid']}>
              <a
                href="https://support.supermap.com/DownloadCenter/ProductPlatform.aspx"
                target="_blank"
                rel="noopener noreferrer"
                className={styles['resource-card']}
              >
                <div className={styles['resource-icon']}>
                  <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
                <h3>SuperMap 软件下载</h3>
                <p>SuperMap iDesktop / iServer 等全线产品官方下载中心</p>
                <span className={styles['resource-link']}>
                  前往下载 <ArrowRightOutlined />
                </span>
              </a>
              <a
                href="https://www.supermapol.com/console/license/triallicense/triallicensepage"
                target="_blank"
                rel="noopener noreferrer"
                className={styles['resource-card']}
              >
                <div className={styles['resource-icon']}>
                  <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="16" rx="2" />
                    <line x1="7" y1="9" x2="17" y2="9" />
                    <line x1="7" y1="13" x2="13" y2="13" />
                    <path d="M15 16l2 2 4-4" />
                  </svg>
                </div>
                <h3>软件许可申请</h3>
                <p>免费申请 SuperMap 试用许可，激活软件全部功能</p>
                <span className={styles['resource-link']}>
                  立即申请 <ArrowRightOutlined />
                </span>
              </a>
            </div>
          </div>
        </section>

        {/* 赛事速览 */}
        <section className={styles.preview}>
          <div className={styles['preview-inner']}>
            <div className={styles['preview-head']}>
              <h2>赛事速览</h2>
              <Link to="/portal/competition" className={styles['more-link']}>
                查看全部赛事 <ArrowRightOutlined />
              </Link>
            </div>
            {loading ? (
              <div className={styles.loading}>
                <Spin size="large" />
              </div>
            ) : showList.length > 0 ? (
              <div className={styles['competition-grid']}>
                {showList.map((c) => (
                  <SingleCompetition key={c._id} competition={c} publicMode />
                ))}
              </div>
            ) : (
              <div className={styles.empty}>赛事筹备中，敬请期待</div>
            )}
          </div>
        </section>
      </PortalLayout>
    );
  }
}
